var _style, _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000023278876348034253450000000812973882552436149_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 6.2,
    y: 6.5,
    width: 92.1,
    height: 92.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171703783607895658480000013685577472644812189_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000171703783607895658480000013685577472644812189_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.3,6.5H71.3c-4.5,0-8.2,2.7-9.9,6.4c-2.8-0.7-5.9-1-9.1-1s-6.3,0.3-9.1,1c-1.7-3.8-5.6-6.4-9.9-6.4H17.1 c-6,0-11,4.9-11,11c0,2.2,0.7,4.5,1.8,6.3l7,10.5c1.1,1.7,2.7,2.9,4.5,3.8C16,51.7,17,74.8,17,74.4c0,10.5,8.5,18.9,18.9,18.9 c1.7,0,3.4-0.3,4.9-0.7c2.5,3.8,6.7,6.3,11.3,6.3s8.8-2.4,11.3-6.3c1.5,0.4,3.2,0.7,4.9,0.7c10.5,0,18.9-8.5,18.9-18.9 c0-13.7,0.7-25.2-2.4-36.2c1.8-0.8,3.4-2.1,4.5-3.8l7-10.5c1.1-1.8,1.8-4.1,1.8-6.3C98.2,11.4,93.3,6.5,87.3,6.5z M19.5,31.1 l-7-10.5c-0.6-0.8-1-2.1-1-3.2c0-3.1,2.5-5.6,5.6-5.6h15.9c3.1,0,5.6,2.5,5.6,5.6c0,1.1-0.4,2.4-1,3.2l-7,10.5 c-1,1.5-2.8,2.5-4.6,2.5h-2C22.3,33.7,20.5,32.7,19.5,31.1z M52.2,93.2c-2.4,0-4.6-1.1-6.2-3.1c2.5-1.5,4.6-3.8,6.2-6.3 c1.5,2.5,3.6,4.8,6.2,6.3C56.9,92.1,54.6,93.2,52.2,93.2z M49.7,67.8c0.4-1,1.4-1.8,2.5-1.8s2.1,0.7,2.5,1.8l-2.5,2.5L49.7,67.8z  M81.9,74.2c0,7.4-6,13.6-13.6,13.6c-7.1,0-12.9-5.5-13.4-12.4l4.6-4.6c0.6-0.6,0.8-1.3,0.8-2c0-4.5-3.6-8.1-8.1-8.1 s-8.1,3.6-8.1,8.1c0,0.7,0.3,1.4,0.8,2l4.6,4.6c-0.6,7-6.4,12.4-13.4,12.4c-7.4,0-13.6-6-13.6-13.6c0-0.7-1-22.4,2.2-35.1h1.4 c3.6,0,7.1-1.8,9.1-4.9l7-10.5c1-1.5,1.7-3.5,1.8-5.6c2.5-0.6,5.2-1,8.1-1c2.9,0,5.6,0.3,8.1,1c0.1,2,0.8,3.9,1.8,5.6l7,10.5 c0.4,0.7,1,1.4,1.7,2c-2.2-1.5-4.9-2.5-7.7-2.5c-7.4,0-13.6,6-13.6,13.6c0,7.4,6,13.6,13.6,13.6c7.4,0,13.6-6,13.6-13.6 c0-3.9-1.7-7.6-4.5-9.9c1.8,1.3,3.9,2,6.2,2h1.4C82.6,49.3,81.9,60.1,81.9,74.2z M71.1,47.2c0,4.5-3.6,8.1-8.1,8.1 s-8.1-3.6-8.1-8.1s3.6-8.1,8.1-8.1S71.1,42.8,71.1,47.2z M92,20.8l-7,10.5c-1,1.5-2.9,2.5-4.9,2.5h-2c-1.8,0-3.6-1-4.6-2.5 l-7-10.5c-0.6-0.8-1-2.1-1-3.2c0-3.1,2.5-5.6,5.6-5.6h15.9c3.1,0,5.6,2.5,5.6,5.6C92.9,18.7,92.5,20,92,20.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5,49.9c1.5,0,2.7-1.3,2.7-2.7c0-1.5-1.3-2.7-2.7-2.7c-1.5,0-2.7,1.3-2.7,2.7C38.7,48.6,39.9,49.9,41.5,49.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63,49.9c1.5,0,2.7-1.3,2.7-2.7c0-1.5-1.3-2.7-2.7-2.7c-1.5,0-2.7,1.3-2.7,2.7C60.4,48.6,61.6,49.9,63,49.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanine);
export default __webpack_public_path__ + "static/media/canine.c6bd002fec5c150460841f6f4e5c2093.svg";
export { ForwardRef as ReactComponent };